import Icon from 'veui/components/Icon'

Icon.register({
  'thumb-up-filled': {
    paths: [
      {
        d: 'M715.27 246.33A63.91 63.91 0 00666.7 224H480V106.25a74.26 74.26 0 00-134.68-43.16L207.53 256H96a32 32 0 00-32 32v384a32 32 0 0032 32h434.19a160 160 0 00158.14-135.67L730 297.73a63.91 63.91 0 00-14.73-51.4zM128 640V320h64v320h-64z'
      }
    ],
    width: '768',
    height: '768'
  }
})
